import { LogoAlign } from '@tink/config/src/tinkLinkConfig';
import { responsiveSize, ResponsiveSizeTypes, styled } from '../../../core/theme/styled';

/* An empty header that can be rendered in cases when we need to hide header.
  For now it is with default (0) height, but we might want to style it properly later.
*/
export const HiddenHeader = styled.header`
  margin-top: env(safe-area-inset-top);
`;

type StyledHeaderProps = {
  addBottomMargin: boolean;
};

export const StyledHeader = styled.header<StyledHeaderProps>`
  /* we want empty header to keep its shape */
  height: 60px;
  /* make sure header is full width e.g. on 404 it's not by default */
  width: 100%;
  display: flex;
  column-gap: ${(props) => props.theme.sizes.normal};
  align-items: center;
  flex-wrap: nowrap;
  margin-top: env(safe-area-inset-top);
  padding: ${(props) => props.theme.sizes.normal};
  ${(props) =>
    props.addBottomMargin &&
    responsiveSize({ type: ResponsiveSizeTypes.MB, size: props.theme.sizes.xxsmall })}
  flex-shrink: 0;
  justify-content: space-between;
`;

export const StyledLoadingHeader = styled.header<StyledHeaderProps>`
  /* we want empty header to keep its shape */
  height: 60px;
  /* make sure header is full width e.g. on 404 it's not by default */
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: ${(props) => props.theme.sizes.xsmall};
  margin-top: env(safe-area-inset-top);
  margin-bottom: ${(props) => (props.addBottomMargin ? props.theme.sizes.large : 0)};
  flex-shrink: 0;
`;

export const StyledClientLogo = styled.img`
  max-width: 200px;
  height: 32px;
  object-fit: contain;
`;

type StyledLogoContainerProps = {
  logoAlign: LogoAlign;
};

export const StyledLogoContainer = styled.div<StyledLogoContainerProps>`
  width: 100%;
  display: flex;
  justify-content: ${({ logoAlign }) => (logoAlign === 'CENTER' ? 'center' : 'flex-start')};
`;
